import { createStore } from 'vuex'

export default createStore({
  state: {
    words: [],
    isLoading: false,
    user: null
  },
  getters: {
  },
  mutations: {
    setWords(state, payload) {
      state.words = payload.words
    },
    setIsLoading(state, payload) {
      state.isLoading = payload.isLoading
    },
    setUser(state, payload) {
      state.user = payload.user
    }
  },
  actions: {
  },
  modules: {
  }
})
